<template>
    <el-main class="container">
        <div class="form-box">
            <el-form ref="queryFormRef" :model="queryForm" size="small" :inline="true">
                <el-form-item label="上传日期">
                    <date-picker class="query_form_item" style="width: 240px;" v-model="billDate" type="daterange" align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions">
                    </date-picker>
                </el-form-item>
                <el-form-item label="标题">
                    <el-input style="width: 180px;" placeholder="请输入" v-model="queryForm.title" clearable></el-input>
                </el-form-item>
                <el-form-item label="栏目">
                    <el-select v-model="queryForm.column" placeholder="请选择" clearable multiple collapse-tags>
                        <el-option
                            v-for="item in EVideoColumnList"
                            :key="item.value"
                            :label="item.cname"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="text-align: center;">
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                    <el-button @click="onReset">重置</el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="box" :style="{height: boxHeight + 'px'}">
            <div class="left-box">
                <div class="table-box">
                    <el-table :data="tableData" ref="table" size="mini" v-loading="tableIsLoading" border stripe height="100%" max-height="100%">
                        <el-table-column type="index" align="center" width="40" :index="indexMethod">
                        </el-table-column>
                        <el-table-column align="center" label="栏目" width="70">
                            <template slot-scope="{ row }">
                                <div>{{ row.videoColumn == 'DA_KA_FANG_TAN'? '大咖访谈'
                                :row.videoColumn == 'JIAO_CHENG_ZHUAN_QU'? '教程专区'
                                :row.videoColumn == 'DIAN_NAO_HOU_TAI'? '销售后台'
                                :row.videoColumn == 'XIAO_SHOU_JI_QIAO'? '技能提升':'' }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="title" align="center" label="标题" min-width="150">
                            <template slot-scope="{ row }">
                                <div class="row">
                                    <p class="table-title-box"><span>标题：</span>{{row.title}}</p>
                                    <p><span>上传人：</span>{{row.createUserName}}</p>
                                    <p><span>上传时间：</span>{{row.createTime}}</p>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="coverUrl" align="center" label="封面预览" min-width="120">
                            <template slot-scope="{ row }">
                                <el-image style="width: 100%;display: block; margin: 0 auto" :src="row.coverUrl" :preview-src-list="[row.coverUrl]" fit="cover">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="视频地址" min-width="150">
                            <template slot-scope="{ row }">
                                <div>{{ row.videoUrl }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="playTimes" align="center" label="浏览量" width="70"></el-table-column>
                        <el-table-column prop="status" align="center" label="操作" width="130">
                            <template slot-scope="{ row }">
                                <div style="text-align: left;">
                                    <el-button type="text" @click="deleteImg(row.id)">删除</el-button>
                                    <br>
                                    <el-checkbox v-model="row.top" @change="toppingHandle(row)">首页显示<span v-if="row.top">({{ row.columnTopNum }}/2)</span></el-checkbox>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="paginationArgs.current" :page-sizes="[10, 20, 100]" :page-size="paginationArgs.size" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
            <el-aside style="width: 35%; height: 100%;">
                <el-form ref="addFormRef" :model="addForm" size="small" style="margin-top: 50px;" label-position="right">
                    <el-form-item prop="file">
                        <el-upload class="upload-demo" :class="choosed ? 'none' : ''" list-type="picture-card" drag action="#" :auto-upload="false" :limit="1" :on-change="handleChange" :on-remove="handleRemove" ref="upload">
                            <template slot="default" v-if="!choosed">
                                <p>将图片拖到此处或点击选择<br />仅支持上传jpg/png格式文件<br />单个文件不能超过500kb</p>
                                <div class="upload-btn">点击上传</div>
                            </template>
                        </el-upload>
                    </el-form-item>
                    <el-form-item label="标题" prop="title" label-width="80px">
                        <el-input style="width: 250px;" placeholder="请输入" v-model="addForm.title" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="视频地址" prop="videoUrl" label-width="80px">
                        <el-input
                            style="width: 250px;"
                            type="textarea"
                            :rows="2"
                            placeholder="请输入"
                            v-model="addForm.videoUrl"
                            clearable>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="栏目" prop="videoColumn" label-width="80px">
                        <el-select v-model="addForm.videoColumn" placeholder="请选择" style="width: 250px;">
                            <el-option
                                v-for="item in EVideoColumnList"
                                :key="item.value"
                                :label="item.cname"
                                :value="item.name">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style="text-align: center;">
                        <el-button @click="onAddReset">取消</el-button>
                        <el-button type="primary" @click="onAddSubmit">确定</el-button>
                    </el-form-item>
                </el-form>
            </el-aside>
        </div>
    </el-main>
</template>
<script>
import datePicker from '@/components/common/datePicker.vue'
import { pickerOptions, getAddDate, getNowFormatDate, toRawType } from '@/assets/js/common.js'
export default {
    name: 'VideoManagement',
    components: {
        datePicker,
    },
    data() {
        return {
            billDate: [getAddDate(-30), getNowFormatDate()],
            queryForm: {
                createBeg: '',
                createEnd: '',
                column: [],
                title: ''
            },
            pickerOptions: pickerOptions,
            tableData: [],
            tableIsLoading: false,
            paginationArgs: {
                size: 20,
                current: 1,
            },
            total: 0,
            boxHeight: 0,
            addForm: {
                model: { submitName: 'modelId', selected: [], valueIsObj: true, isMultiple: false, isAll: false, isShowAll: false, isFilterable: true, isRemote: true, isPagination: true, isReSearch: false, list: [], placeholder: '请选择模板', request: { url: '/Account/monitorCenterEnterDefine/selectModelList.html', type: 'post', params: { page: 1, size: 5 }, text: 'modelId', value: 'modelId' } },
                title: '',
                videoUrl: '',
                videoColumn: '',
                fill: {}
            },
            choosed: false,
            EVideoColumnList: [],
            radio: true
        }
    },
    created() {
        this.getTableList()
        // 获取栏目类型
        this.getvideoColumn()
    },
    mounted() {
        this.onresize()
        window.addEventListener('resize', () => this.onresize(), false)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onresize(), false)
    },
    computed: {

    },
    methods: {
        async getvideoColumn() {
            const { data: res } = await this.$http.get('/erpnew/account/c/reada46ceb/enums/EVideoColumnFront')
            console.log(res)
            this.EVideoColumnList = res.data.items
        },
        onresize() {
            // this.$refs.table.doLayout()
            this.boxHeight = parseInt(Number($(".container").height()) - Number($(".form-box").height()) - 6)
        },
        async getTableList() {

            this.queryForm.createBeg = this.billDate? this.billDate[0]:null
            this.queryForm.createEnd = this.billDate? this.billDate[1]:null

            this.tableIsLoading = true
            // { ...this.queryForm, ...this.paginationArgs }
            try {
                const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/video/page', { ...this.queryForm, ...this.paginationArgs } )
                this.tableIsLoading = false
                if (res.code != '0') return this.$message.error(res.message)
                this.total = Number(res.data.total)
                this.tableData = res.data.records
                console.log(this.tableData)
            } catch (e) {
                console.log(e)
                this.tableIsLoading = false
            }
        },
        indexMethod(index) {
            return ((this.paginationArgs.current - 1) * this.paginationArgs.size) + (index + 1)
        },
        // 监听pagesize的改变
        handleSizeChange(newSize) {
            this.paginationArgs.size = newSize
            this.getTableList()
        },
        // 监听页码值的改变
        handleCurrentChange(newPage) {
            this.paginationArgs.current = newPage
            this.getTableList()
        },
        onSubmit() {
            this.paginationArgs.current = 1
            this.getTableList()
        },
        onReset() {
            this.billDate = [getAddDate(-30), getNowFormatDate()]
            this.queryForm = {
                createBeg: '',
                createEnd: '',
                column: '',
                title: ''
            }
            this.paginationArgs.current = 1
            this.getTableList()
        },
        async deleteImg(id) {
            const confirmResult = await this.$confirm('此操作为删除操作, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).catch(err => err)
            if (confirmResult !== 'confirm') return false
            const loading = this.$loading({
                lock: true,
                text: '删除中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            let url = `/erpnew/account/c/reada46ceb/video/${id}/delete`
            const { data: res } = await this.$http.post(url)
            loading.close()
            if (res.code != '0') return this.$message.error(res.message)
            this.$message.success('删除成功')
            this.getTableList()
        },
        handleChange(file) {
            console.log(file);
            const raw = file.raw
            const isJPG = raw.type === 'image/jpeg' || raw.type === 'image/png';
            const isLt2M = raw.size / 1024 < 500;
            if (!isJPG) {
                this.$refs.upload.clearFiles()
                this.addForm.file = {}
                this.choosed = false
                return this.$message.error('上传图片只能是 JPG/PNG 格式!');
            }
            if (!isLt2M) {
                this.$refs.upload.clearFiles()
                this.addForm.file = {}
                this.choosed = false
                return this.$message.error('上传图片大小不能超过 500KB!');
            }
            this.addForm.file = file
            this.choosed = true
        },
        handleRemove(file) {
            console.log(file);
            this.addForm.file = {}
            this.choosed = false
        },
        async onAddSubmit() {
            console.log(this.addForm)
            if (!this.addForm.file.url) return this.$message.error('请选择图片')
            if (!this.addForm.title) return this.$message.error('请填写标题')
            if (!this.addForm.videoUrl) return this.$message.error('请填写视频链接')
            if (!this.addForm.videoColumn) return this.$message.error('请选择栏目')
            let obj = {
                title: this.addForm.title,
                videoUrl: this.addForm.videoUrl,
                videoColumn: this.addForm.videoColumn
            }
            const loading = this.$loading({
                lock: true,
                text: '上传图片中，请耐心等待',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            var formData = new FormData();
            delete this.addForm.file.url.uid
            formData.append("file", this.addForm.file.raw);
            console.log(formData)
            const { data: res } = await this.$http.post('/android/AcceptPictureServlet2', formData)
            console.log(res)
            if (res.code == 'ERROR') {
                loading.close()
                return this.$message.error('图片上传错误')
            }
            obj.coverUrl = res.result
            // this.onSubmitInfo()
            console.log(obj)
            // const { data: ret } = await this.$http.post('/Account/monitorCenterEnterDefine/addBillPic.html', this.Qs.stringify(obj))
            const { data: ret } = await this.$post('/erpnew/account/c/reada46ceb/video', obj)
            loading.close()
            if (ret.code != '0') return this.$message.error(ret.message)
            this.$message.success('成功')
            this.paginationArgs.page = 1
            this.getTableList()
            this.onAddReset()
        },
        onAddReset() {
            this.$refs.addFormRef.resetFields()
            this.$refs.upload.clearFiles()
            this.addForm.file = {}
            this.choosed = false
        },
        // 置顶、取消置顶
        async toppingHandle(row) {
            console.log(row)
            const { data: res } = await this.$post(`/erpnew/account/c/reada46ceb/video/${row.id}/top`)
            console.log(res)
            if (res.code != '0') {
                row.top = !row.top
                this.$message.error(res.message)
                return
            }
            this.$message.success('成功')
            this.getTableList()
        }
    }
}
</script>
<style lang="less" scoped>
.el-main {
    padding: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.form-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    .el-form-item {
        margin-bottom: 12px;
    }
}

.box {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;

    .left-box {
        flex: 1;
        height: 100%;

        .table-box {
            height: calc(100% - 32px);

            .el-table {
                // flex: 1;

                ::v-deep .el-table__body {
                    .row {
                        text-align: left;
                        p {
                            // display: flex;
                            // flex-direction: row;
                            // align-items: center;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 1;
                            line-clamp: 1;
                            -webkit-box-orient: vertical;
                            span {
                                width: 62px;
                                display: inline-block;
                                text-align: left;
                                text-align-last: justify
                            }
                        }
                    }

                    .button {
                        width: 120px;
                        height: 32px;
                        text-align: center;
                        color: #2A82E4;
                        font-size: 14px;
                        border-radius: 4px;
                        border: 1px solid #2A82E4;
                        line-height: 32px;
                        margin: 0 auto;
                        cursor: pointer;

                        &.status {
                            background-color: #2A82E4;
                            color: #FFFFFF;
                        }
                    }

                    .delete {
                        font-size: 20px;
                        padding: 0;
                    }
                }
            }
        }
    }

    .el-aside {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        ::v-deep .el-upload {
            width: 300px;
            height: 200px;
            position: relative;
            border: none;

            .el-upload-dragger {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 200px;

                p {
                    font-size: 12px;
                    color: #A6A6A6;
                    line-height: 28px;
                }

                .upload-btn {
                    width: 120px;
                    height: 32px;
                    text-align: center;
                    font-size: 14px;
                    color: #FFFFFF;
                    line-height: 32px;
                    border-radius: 4px;
                    background: #2A82E4;
                    margin-top: 30px;
                }
            }
        }

        ::v-deep .el-upload-list {
            width: 300px;
            height: 200px;
            background-color: #fbfdff;
            border: 1px dashed #c0ccda;
            border-radius: 6px;
            box-sizing: border-box;
            cursor: pointer;
            line-height: 146px;
            vertical-align: top;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            z-index: 0;
            opacity: 0;

            li {
                display: block;
                margin: 0 auto;
                width: 200px;
                height: auto;
                border: none;

                img {
                    width: 200px;
                    height: auto;
                    display: block;
                }
            }
        }


        .none {
            ::v-deep .el-upload--picture-card {
                z-index: 1;
            }

            ::v-deep .el-upload-list {
                z-index: 2;
                opacity: 1;
            }
        }
    }
}
.table-title-box {
    text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>